export const getOneToOneAvatar = (source: Record<string, any> = {}) =>
  source.empAvatar || source.empAvater || source.empHeadImage || ''

export const getOneToOneNickname = (source: Record<string, any> = {}) =>
  source.empNickname || source.adviserName || ''
